// botContentActions

// Action Types
export const BOT_CONTENT_ACTION_TYPES = {
  // Core data
  SET_BOT_CONTENT: 'SET_BOT_CONTENT',

  // UI states only
  SET_LOADING: 'SET_LOADING',
  SET_UPDATING: 'SET_UPDATING',
  SET_ALERT: 'SET_ALERT',

  // Reset
  RESET_BOT_CONTENT: 'RESET_BOT_CONTENT'
};

// Action Creators - only what we actually use
export const setBotContent = (botContent) => ({
  type: BOT_CONTENT_ACTION_TYPES.SET_BOT_CONTENT,
  payload: botContent
});

export const setLoading = (loading) => ({
  type: BOT_CONTENT_ACTION_TYPES.SET_LOADING,
  payload: loading
});

export const setUpdating = (updating) => ({
  type: BOT_CONTENT_ACTION_TYPES.SET_UPDATING,
  payload: updating
});

export const setAlert = (alert) => ({
  type: BOT_CONTENT_ACTION_TYPES.SET_ALERT,
  payload: alert
});

export const resetBotContent = () => ({
  type: BOT_CONTENT_ACTION_TYPES.RESET_BOT_CONTENT
});